const Error = () =>{

    return (
        <>
            <h1>Error component</h1>
        </>
    )

}

export default Error